import React from "react";
import useSound from "use-sound";
import { useSelector, useDispatch } from "react-redux";
import { updateMode } from "../../redux/reducers/ModeReducer";
import { selectGrade } from "../../redux/reducers/PracticeDataReducer";
import ContentContainer from "../../components/ContentContainerComp/ContentContainer";
import Class4Bg from "../../assets/images/background/Class4Bg.png";
import Class5Bg from "../../assets/images/background/Class5Bg.png";
import Class6Bg from "../../assets/images/background/Class6Bg.png";
import ButtonPlay from "../../assets/images/others/ButtonPlay.png";
import LockIcon from "../../assets/images/others/LockIcon.png";
import DBLPOP from "../../assets/music/DBLPOP.mp3";
import s from "./style.module.css";

const styles = {
  lockerStyle: {
    // marginTop: "-25px",
    width: "80%",
    height: "80%",
    maxWidth: "124px",
    maxHeight: "146px",
  },
};
const ClassArray = [
  { id: 1, class: 4, classBg: Class4Bg },
  { id: 2, class: 5, classBg: Class5Bg },
  { id: 3, class: 6, classBg: Class6Bg },
];
const ClassContainer = () => {
  const [play] = useSound(DBLPOP);
  const userInfo = useSelector((state) => state.UserInfo);
  const dispatch = useDispatch();
  const currentUserClass = userInfo.grade;
  const handleEnterClass = (id) => {
    // if (id <= currentUserClass) {
    dispatch(updateMode({ mode: 1, step: 3 }));
    dispatch(selectGrade(id));
    // }
  };

  return (
    <ContentContainer
      typeHeader={1}
      onCenter
      textHeader="ระดับชั้น"
      disableNext={1}
      disableBack={1}
    >
      <div className={s.ClasslContainer}>
        <div className={s.ClassContent}>
          {ClassArray.map((item, idx) => (
            <div
              key={idx}
              className={s.ClassBackground}
              style={{
                background: `url(${item.classBg})`,
                backgroundSize: "100% 100%",
                filter:
                  currentUserClass !== item.class ? "grayscale(100%)" : null,
              }}
            >
              <div
                style={{
                  width: "10vmax",
                  height: "15vmax",
                }}
              >
                {currentUserClass !== item.class ? (
                  <div className={s.LockerImgContainer}>
                    <img
                      style={styles.lockerStyle}
                      src={LockIcon}
                      alt="class"
                    />
                  </div>
                ) : (
                  <p className={s.ClassText}>ป.{item.class}</p>
                )}
              </div>

              {item.class === currentUserClass && (
                <div
                  className={s.ButtonPlayContainer}
                  onClick={() => {
                    handleEnterClass(item.class);
                    play();
                  }}
                >
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      maxWidth: "90px",
                      maxHeight: "90px",
                    }}
                    src={ButtonPlay}
                    alt="class"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </ContentContainer>
  );
};

export default ClassContainer;
